<template>
  <div style="width: 94% !important; margin-left: 3% !important">
    <v-card-text
      class="common-datepicker py-0 px-0"
      :class="isSmallDevice ? 'small-device' : ''"
    >
      <v-col
        class="py-0 px-0"
        cols="6"
        style="
          font-weight: bold !important;
          display: inline-flex !important;
          vertical-align: top !important;
          margin-top: 6px !important;
        "
      >
        {{ labelName }}
      </v-col>
      <v-col
        cols="6"
        class="py-0 px-0"
        style="font-size: 0.85rem; display: inline-flex !important"
      >
        <v-dialog
          v-if="!isMobile"
          v-model="commonDatePicker"
          :close-on-content-click="false"
          :nudge-right="100"
          width="500"
          transition="scale-transition"
          offset-y
          persistent
          :rules="[(v) => !!v || 'Bitte wählen Sie das Stelldatum']"
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- v-model="commonDateFormatted" -->
            <v-text-field
              :disabled="!isClickable"
              v-model="exisitingDate"
              append-icon="mdi-calendar-clock"
              :label="itemMessage"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || '']"
            ></v-text-field>
          </template>
          <template v-if="showDialog">
            <v-sheet class="date-picker-overlay" style="border-radius: 10px !important; overflow: hidden">
              <div class="date-picker-title">
                <p style="margin-left: auto; padding-left: 2rem">
                  Wunschtermin ändern
                </p>
                <v-icon
                  style="
                    color: rgba(145, 145, 145, 0.8) !important;
                    margin-left: auto;
                    padding-right: 0.5rem;
                    margin-top: -1rem;
                  "
                  @click="closeDialog"
                  >mdi-close-circle-outline</v-icon
                >
              </div>
              <v-divider style="margin-top: -0.5rem" />
              <v-date-picker
                v-model="commonDate"
                class="date-picker"
                :events="[exisitingDatesForDatePicker]"
                locale="de"
                :first-day-of-week="1"
                @input="setCommonDate()"
                :allowed-dates="allowedDates"
                :min="minimumDate"
                no-title
                style="font-size: 0.85rem; min-width: 90%"
                :show-current="true"
              ></v-date-picker>
              <div class="termin-box" outlined>
                <p class="pt-2">
                  <span class="changes-header pa-0 ma-0"
                    >Geplanter Termin:</span
                  >
                  {{ exisitingDate }}
                </p>
                <p class="pb-2">
                  <span class="changes-header pa-0 ma-0">Neuer Termin:</span>
                  {{ newSelectedDate }}
                </p>
              </div>
              <div class="termin-box" outlined>
                <template v-if="showHinweisBox">
                  <p class="pa-3" style="text-align: left">
                    <!-- :class="hideHinweisBox ? 'hide-hinweis-box' : ''" -->
                    <span
                    class="changes-header pa-0 ma-0"
                    >Hinweis:</span><br />
                    Bitte beachten Sie, dass die Einhaltung einer Terminänderung für
                    den nächsten Werktag aus Gründen der Disposition nicht garantiert
                    werden kann. Sollten wir Ihren Auftrag nicht wunschgemäß ändern
                    können, werden wir uns telefonisch bei Ihnen melden.
                  </p>
                </template>
              </div>
              <div
                class="text-center pb-1"
                style="padding-bottom: 1.3rem !important"
              >
                <v-btn
                  class="mt-1"
                  color="primary"
                  :min-width="isMobile ? '90%' : '60%'"
                  min-height="50px"
                  rounded
                  :disabled="!setDisabled"
                  @click="setDates"
                  >Wunschtermin jetzt ändern</v-btn
                >
              </div>
            </v-sheet>
          </template>
          <template v-if="!showDialog">
            <v-menu
              v-model="commonDatePicker"
              :close-on-content-click="false"
              :nudge-right="100"
              transition="scale-transition"
              offset-y
              :rules="[(v) => !!v || 'Bitte wählen Sie das Stelldatum']"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :disabled="!isClickable"
                  v-model="commonDateFormatted"
                  append-icon="mdi-calendar-clock"
                  :label="itemMessage"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[(v) => !!v || '']"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="de"
                :first-day-of-week="1"
                v-model="commonDate"
                @input="setCommonDate()"
                :allowed-dates="allowedDates"
                :min="minimumDate"
                style="font-size: 0.85rem"
                data-cy="datePicker"
              ></v-date-picker>
            </v-menu>
          </template>
        </v-dialog>
        <v-bottom-sheet
          v-if="isMobile"
          v-model="commonDatePicker"
          max-width="500"
          :close-on-content-click="false"
          :rules="[(v) => !!v || 'Bitte wählen Sie das Stelldatum']"
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- v-model="commonDateFormatted" -->
            <v-text-field
              :disabled="!isClickable"
              v-model="exisitingDate"
              append-icon="mdi-calendar-clock"
              :label="itemMessage"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || '']"
            ></v-text-field>
          </template>
          <template v-if="showDialog">
            <v-sheet class="date-picker-overlay" style="border-top-left-radius: 10px !important;border-top-right-radius: 10px !important;">
              <div class="date-picker-title">
                <p style="margin-left: auto; padding-left: 2rem">
                  Wunschtermin ändern
                </p>
                <v-icon
                  style="
                    color: rgba(145, 145, 145, 0.8) !important;
                    margin-left: auto;
                    padding-right: 0.5rem;
                    margin-top: -1rem;
                  "
                  @click="closeDialog"
                  >mdi-close-circle-outline</v-icon
                >
              </div>
              <v-divider style="margin-top: -0.5rem" />
              <v-date-picker
                v-model="commonDate"
                class="date-picker"
                :events="[exisitingDatesForDatePicker]"
                locale="de"
                :first-day-of-week="1"
                @input="setCommonDate()"
                :allowed-dates="allowedDates"
                :min="minimumDate"
                no-title
                style="font-size: 0.85rem;"
                :show-current="true"
              ></v-date-picker>
              <div class="termin-box" outlined>
                <p class="pt-2">
                  <span class="changes-header pa-0 ma-0"
                    >Geplanter Termin:</span
                  >
                  {{ exisitingDate }}
                </p>
                <p class="pb-2">
                  <span class="changes-header pa-0 ma-0">Neuer Termin:</span>
                  {{ newSelectedDate }}
                </p>
              </div>
              <div class="termin-box" outlined>
                <template v-if="showHinweisBox">
                  <p class="pa-3" style="text-align: left">
                    <!-- :class="hideHinweisBox ? 'hide-hinweis-box' : ''" -->
                    <span
                    class="changes-header pa-0 ma-0"
                    >Hinweis:</span><br />
                    Bitte beachten Sie, dass die Einhaltung einer Terminänderung für
                    den nächsten Werktag aus Gründen der Disposition nicht garantiert
                    werden kann. Sollten wir Ihren Auftrag nicht wunschgemäß ändern
                    können, werden wir uns telefonisch bei Ihnen melden.
                  </p>
                </template>
              </div>
              <div
                class="text-center pb-1"
                style="padding-bottom: 1.3rem !important"
              >
                <v-btn
                  class="mt-1"
                  color="primary"
                  :min-width="isMobile ? '90%' : '60%'"
                  min-height="50px"
                  rounded
                  :disabled="!setDisabled"
                  @click="setDates"
                  >Wunschtermin jetzt ändern</v-btn
                >
              </div>
            </v-sheet>
          </template>
          <template v-if="!showDialog">
            <v-menu
              v-model="commonDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              :rules="[(v) => !!v || 'Bitte wählen Sie das Stelldatum']"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :disabled="!isClickable"
                  v-model="commonDateFormatted"
                  append-icon="mdi-calendar-clock"
                  :label="itemMessage"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[(v) => !!v || '']"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="de"
                :first-day-of-week="1"
                v-model="commonDate"
                @input="setCommonDate()"
                :allowed-dates="allowedDates"
                :min="minimumDate"
                style="font-size: 0.85rem"
                data-cy="datePicker"
              ></v-date-picker>
            </v-menu>
          </template>
        </v-bottom-sheet>
      </v-col>
    </v-card-text>
  </div>
</template>
<script>
import Vue from "vue";
import { dateFormat } from "@/helpers";
// import DialogDatePicker from "@/components/atoms/DialogDatePicker.vue";

export default Vue.extend({
  props: {
    labelName: String,
    isClickable: Boolean,
    itemMessage: String,
    isSmallDevice: Boolean,
    preselectedDate: String,
    showDialog: Boolean,
    presentDate: String,
    order: Object,
    isMobile: Boolean,
  },
  components: {
    // DialogDatePicker,
  },
  data: () => {
    return {
      commonDatePicker: false,
      commonDateFormatted: "",
      commonDate: "",
      presentSelectedDate: "",
      newSelectedDate: "",
      exisitingDate: "",
      exisitingDatesForDatePicker: "",
      testDate: "",
      checkEl: "",
      setExistingDates: "",
      setDisabled: false,
    };
  },
  mounted() {
    if (this.preselectedDate) {
      this.commonDateFormatted = dateFormat(this.preselectedDate);
    }
    if (this.order && this.order !== "undefined") {
      this.exisitingDate = dateFormat(this.order.desiredDate); // get date already set from object prop
      this.exisitingDatesForDatePicker = this.order.desiredDate.split("T")[0]; // set yyyy-mm-dd in datePicker events for showing selected date,
    }
  },
  methods: {
    closeDialog() {
      this.commonDate = "";
      this.newSelectedDate = "";
      this.commonDatePicker = false; // Close dialog
    },
    setCommonDate() {
      this.setDisabled = true;
      this.commonDateFormatted = dateFormat(this.commonDate);
      if (!this.showDialog) {
        this.commonDatePicker = false;
      }
      this.newSelectedDate = this.commonDateFormatted;
    },
    setDates() {
      this.exisitingDate = dateFormat(this.commonDate);
      if (this.commonDatePicker) {
        this.$emit("set-date-value", this.commonDate);
        this.commonDatePicker = false;
      }
    },
    allowedDates: (val) => new Date(val).getDay() % 6,
  },
  computed: {
    minimumDate() {
      const maximumTimeDate = new Date();
      maximumTimeDate.setHours(12, 0, 0);
      const currentTimeDate = new Date();
      if (
        currentTimeDate >= maximumTimeDate ||
        currentTimeDate.getDay() === 6 ||
        currentTimeDate.getDay() === 0
      ) {
        if (currentTimeDate.getDay() > 4) {
          currentTimeDate.setDate(
            currentTimeDate.getDate() + (currentTimeDate.getDay() === 5 ? 4 : 3)
          );
        } else {
          currentTimeDate.setDate(currentTimeDate.getDate() + 2);
        }
      } else {
        currentTimeDate.setDate(currentTimeDate.getDate() + 1);
      }
      return currentTimeDate.toISOString();
    },
    showHinweisBox(){
      const today = new Date();
      const todayNumber = today.getDay();
      const oldTermin = new Date(`${this.exisitingDatesForDatePicker}T00:00:00`);
      const newTermin = new Date(`${this.commonDate}T00:00:00`);
      const newTimeDiff = Math.abs(today.getTime() - newTermin.getTime());
      const newTerminDiffDays = Math.ceil(newTimeDiff / (1000 * 60 * 60 * 24));
      const timeDiff = Math.abs(today.getTime() - oldTermin.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return diffDays < 2 || (diffDays === 3 && todayNumber === 5) || newTerminDiffDays < 2 || (newTerminDiffDays === 3 && todayNumber === 5);
    }
  },
});
</script>

<style lang="css" scoped>
/* v-picker__body--no-title */
/* .common-datepicker >>> .date-picker >>> .v-picker__body {
  min-width: 500px !important;
} */
.date-picker-overlay {
  width: 100%;
  text-align: center;
  font-size: 0.85rem;
}
.date-picker-title {
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;
}
.date-picker {
  padding-top: 1.5rem;
  padding-bottom: 2rem;
}
.desktop .date-picker-overlay, .desktop .date-picker {
  width: 100%;
  min-width: 90%;
}
.termin-box {
  width: 100%;
  background-color: rgb(229, 248, 244);
  border-color: rgb(229, 248, 244);
  width: 80%;
  margin: auto;
}
.common-datepicker >>> .v-text-field input {
  font-size: 0.85rem !important;
  text-align: right;
}
.common-datepicker >>> .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.common-datepicker >>> .v-icon {
  font-size: 1.25rem !important;
}

.common-datepicker >>> .v-label {
  font-size: 0.85rem !important;
  max-width: 100% !important;
  color: #9e9e9e;
  right: 0px !important;
  left: auto !important;
}
.common-datepicker >>> .v-label--active {
  display: none !important;
}
.common-datepicker >>> .v-input__slot {
  margin-bottom: 5px !important;
}
.common-datepicker >>> .v-input__slot:before {
  border-style: none !important;
}
.common-datepicker >>> .v-text-field__details {
  margin-top: -15px !important;
  width: 80% !important;
  margin-left: 5%;
}
.common-datepicker >>> .v-input__slot:after {
  border-style: none !important;
}
.common-datepicker >>> .v-text-field__details {
  display: none !important;
}
.common-datepicker.small-device >>> * {
  font-size: 0.8rem !important;
}

.changes-header {
  font-size: 0.75rem !important;
  font-weight: bold;
  color: #00b791 !important;
}
.small-device >>> .v-icon {
  font-size: 1.25rem !important;
}
.hide-hinweis-box {
  display: none;
}
</style>
